import * as Sentry from '@sentry/browser';
import * as React from 'react';
import Button from 'reactstrap/lib/Button';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { ApiEndpoints, DevApiEndpoints, IEndpoints } from '../../api/endpoint';
import Input from '../Input/Input';
import './RegisterForm.css';

interface IRegisterFormState {
  [name: string]: number | string;
  postcode: string;
  contactEmail: string;
  city: string;
  phone: string;
  name: string;
  message: string;
  statusColor: string;
}

interface IRegisterFromProps {
  changeRegisterSuccess(): void;
}

export default class RegisterForm extends React.Component<IRegisterFromProps, IRegisterFormState> {
  constructor(props: IRegisterFromProps) {
    super(props);
    this.state = {
      city: '',
      contactEmail: '',
      message: '',
      name: '',
      phone: '',
      postcode: '',
      statusColor: ''
    };
    this._handleOnChange = this._handleOnChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  private _handleOnChange(
    name: 'postcode' | 'contactEmail' | 'city' | 'phone' | 'name',
    value: number | string
  ) {
    this.setState({ [name]: value });
  }

  private async _handleSubmit(event: any) {
    event.preventDefault();

    const { city, name, contactEmail, phone, postcode } = this.state;
    const ENDPOINTS: IEndpoints = window.ENV === 'production' ? ApiEndpoints : DevApiEndpoints;

    const url = ENDPOINTS.POST_REGISTER;
    try {

      const response = await fetch(url, {
        body: JSON.stringify({
          city,
          contactEmail,
          name,
          phone,
          postcode
        }),
        headers: {
          'Access-Control-Allow-Headers':
            'X-Requested-With,Content-Type, Authorization, Access-Control-Allow-Origin, Access-Control-Allow-Headers, Access-Control-Allow-Methods,Allow,Access-Control-Allow-Credentials',
          'Access-Control-Allow-Methods': 'GET, OPTIONS, POST, PUT, DELETE, HEAD',
          'Access-Control-Allow-Origin': '*',
          Allow: 'GET, HEAD, POST, PUT, DELETE, OPTIONS',
          'Content-Type': 'application/json',
          Credentials: 'include'
        },
        method: 'POST'
      });
      
      let data: any;
      if (response.ok) {
        data = await response.json();
      }
  
      switch (data.message) {
        case 'Success':
          this.props.changeRegisterSuccess();
          break;
        case 'User already exist':
          await this.setState({
            message: 'Cet établissement a déjà un compte Whisperies',
            statusColor: 'red'
          });
          break;
        case 'Username already exist':
          await this.setState({
            message: ' Cet établissement a déjà un compte Whisperies',
            statusColor: 'red'
          });
          break;
        case 'Email already exist':
          await this.setState({
            message: 'Cette adresse mail est déjà utilisée',
            statusColor: 'red'
          });
          break;
        default:
          Sentry.configureScope( (scope) => {
            scope.setLevel(Sentry.Severity.Error);
            scope.setExtra("data", JSON.stringify(data));
            scope.setExtra("city", city);
            scope.setExtra("name", name);
            scope.setExtra("contactEmail", contactEmail);
            scope.setExtra("phone", phone);
            scope.setExtra("postcode", postcode);
          });
          Sentry.captureMessage("Error: submit register");

          await this.setState({
            message: 'Oups ! Une erreur est survenue.',
            statusColor: 'red'
          });
          break;
      }
    }
    catch(error) {
      Sentry.configureScope( (scope) => {
        scope.setLevel(Sentry.Severity.Error);
        scope.setExtra("error", JSON.stringify(error));
        scope.setExtra("city", city);
        scope.setExtra("name", name);
        scope.setExtra("contactEmail", contactEmail);
        scope.setExtra("phone", phone);
        scope.setExtra("postcode", postcode);
      });
      Sentry.captureMessage("Error: submit register");

      await this.setState({
        message: 'Oups ! Une erreur est survenue.',
        statusColor: 'red'
      });
    }
  }

  public render() {
    return (
      <div id='RegisterForm'>
        <div className='containerRegister'>
          <div className='title'>
            <div>
              <h4>Inscrivez-vous !</h4>
            </div>
            <div>
              <small>
                Et découvrez l'intégralité de la ressource Whisperies en illimité pendant 7 jours !
              </small>
            </div>
          </div>
          <div className='nomEtablissement'>
            {/* Nom de l'établissement */}
            <FormGroup row={true}>
              <Label style={{ textAlign: 'left', fontSize: '0.8rem' }}>Etablissement</Label>
              <Input
                type='text'
                name='name'
                placeholder="Nom de l'établissement"
                handleOnChange={this._handleOnChange}
              />
            </FormGroup>
          </div>
          <div className='adresse'>
            {/* Code Postal */}
            <div className='codePostal'>
              <FormGroup row={true}>
                <Label style={{ textAlign: 'left', fontSize: '0.8rem' }}>Code Postal</Label>
                <Input
                  type='text'
                  name='postcode'
                  placeholder='Code Postal'
                  handleOnChange={this._handleOnChange}
                />
              </FormGroup>
            </div>
            {/* ville */}
            <div className='ville'>
              <FormGroup row={true}>
                <Label style={{ textAlign: 'left', fontSize: '0.8rem' }}>Ville</Label>
                <Input
                  type='text'
                  name='city'
                  placeholder='Ville'
                  handleOnChange={this._handleOnChange}
                />
              </FormGroup>
            </div>
          </div>
          <div className='email_password'>
            {/* contact_email */}
            <div>
              <FormGroup row={true}>
                <Label style={{ textAlign: 'left', fontSize: '0.8rem' }}>Email</Label>
                <Input
                  type='email'
                  name='contactEmail'
                  placeholder='Email'
                  handleOnChange={this._handleOnChange}
                />
              </FormGroup>
            </div>
          </div>
          <div className='telephone'>
            {/* Telephone utilsateur */}
            <div>
              <FormGroup row={true}>
                <Label style={{ textAlign: 'left', fontSize: '0.8rem' }}>Téléphone</Label>
                <Input
                  type='tel'
                  name='phone'
                  placeholder='Numéro de télephone'
                  handleOnChange={this._handleOnChange}
                />
              </FormGroup>
            </div>
          </div>
          <div className='btn_link'>
            <div>
              <Button className='btnRegister' block={true} onClick={this._handleSubmit}>
                Je m'inscris !
              </Button>
              <small className='message' style={{ color: this.state.statusColor }}>
                {this.state.message}
              </small>
              <div className='linkAlready'>
                <a
                  target='_blank'
                  href={
                    window.ENV === 'production'
                      ? 'https://mediatheque.whisperies.com/catalogue/'
                      : 'https://mediatheque-dev.whisperies.com/catalogue/'
                  }
                >
                  Déjà inscrit ? Connectez-vous !
                </a>
              </div>
            </div>
          </div>
          <div className='rowTermsConditions'>
            <div>
              <small className='termsConditions'>
                En vous inscrivant, <br />
                <a
                  target='_blank'
                  href={
                    window.ENV === 'production'
                      ? 'https://www.whisperies.com/conditions-d-utilisation'
                      : 'https://dev.whisperies.com/conditions-d-utilisation'
                  }
                >
                  vous acceptez les conditions d'utilisation
                </a>
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Register/RegisterForm.tsx